import { Link, useLocation } from "react-router-dom";

export type Tab = {
  label: string;
  to: string;
  // When `to === "/" we usually only want an exact match — without `exact`
  // the root tab would be active on every page. Defaults to `to === "/"`.
  exact?: boolean;
};

type Props = {
  tabs: ReadonlyArray<Tab>;
  className?: string;
};

export function Tabs({ tabs, className }: Props) {
  const { pathname } = useLocation();

  const isActive = (tab: Tab) => {
    const exact = tab.exact ?? tab.to === "/";
    if (exact) return pathname === tab.to;
    return pathname === tab.to || pathname.startsWith(tab.to + "/");
  };

  return (
    <nav
      className={
        "flex gap-6 border-b border-slate-200" +
        (className ? ` ${className}` : "")
      }
      aria-label="Tabs"
    >
      {tabs.map((tab) => {
        const active = isActive(tab);
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={
              "-mb-px border-b-2 px-1 py-3 text-sm font-medium transition-colors " +
              (active
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700")
            }
            aria-current={active ? "page" : undefined}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
